import ShipperDetail from "@/classes/bookings/ShipperDetail";
import ConsigneeDetail from "@/classes/bookings/ConsigneeDetail";
import {useResetValidation} from "@/composables/common/useResetValidation";

export function useClearCompany(area, props, validationViewModel) {

    props.modelValue.isUpdate[area] = false;

    if (area === 'shipper') return props.modelValue.shipper = new ShipperDetail();
    if (area === 'consignee') return props.modelValue.consignee = new ConsigneeDetail();

    useResetValidation(props.modelValue[area], validationViewModel.value[props.validationViewModelSection]);
    props.modelValue.tileValidation[area] = true;

}
